/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Michael Diponio
 * Created: 26/04/2022
 */

import * as React from 'react';

import { Document, Font } from '@react-pdf/renderer';
import Summary from '@/wpt-lib/pdf/Summary';
import Leave from '@/wpt-lib/pdf/Leave';
import Goals from '@/wpt-lib/pdf/Goals';

import AkademieRegular from '../assets/fonts/NB_Akademie_Std_Edition_OTF/NB Akademie Std Regular';
import AkademieItalic from '../assets/fonts/NB_Akademie_Std_Edition_OTF/NB Akademie Std Italic';
import AkademieBold from '../assets/fonts/NB_Akademie_Std_Edition_OTF/NB Akademie Std Bold';
import Review from '@/wpt-lib/pdf/Review';
import useData from '@/wpt-lib/pdf/useData';
import Training from '@/wpt-lib/pdf/Training';
import Considerations from '@/wpt-lib/pdf/Considerations';
import Activities from '@/wpt-lib/pdf/Activities';
import { formatName } from '@/wpt-lib/utils/formatName';
import Behavioural from '@/wpt-lib/pdf/behavioural/Behavioural';

Font.register({
    family: 'Akademie',
    fonts: [
        { src: AkademieRegular },
        { src: AkademieItalic, fontStyle: 'italic' },
        { src: AkademieBold, fontWeight: 'bold' },
    ],
});

const WorkplanPDF = ({ charts }: { charts: JSX.Element[] }) => {
    const { workplan, user } = useData();

    return (
        <Document
            title={`Workplan ${workplan.year} for ${formatName(user)}`}
            author={user.staffId}
            subject={`Workplan ${workplan.year}`}
            creator="Work Planning Tool"
            producer="UTS Rapido"
        >
            <Summary charts={charts} />
            <Behavioural />
            <Goals />
            <Activities />
            <Leave />
            <Training />
            <Considerations />
            <Review />
        </Document>
    );
};

export default WorkplanPDF;
